import { makeStyles } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';

import {
  EntityKindPicker,
  EntityTypePicker,
  UserListPicker,
  EntityOwnerPicker,
  EntityLifecyclePicker,
  EntityTagPicker,
  EntityProcessingStatusPicker,
  EntityNamespacePicker,
} from '@backstage/plugin-catalog-react';

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: 40,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(1.5),
    borderBottom: `2px solid ${theme.palette.divider}`,
    fontFamily: "'Poppins', sans-serif",
    fontSize: '0.6875rem',
    fontWeight: 600,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
  },
  filterIcon: {
    color: theme.palette.secondary.main,
    fontSize: 16,
  },
  separator: {
    marginTop: theme.spacing(3),
    paddingTop: theme.spacing(2),
    borderTop: `2px solid ${theme.palette.divider}`,
  },
  quickAccessTitle: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: '0.6875rem',
    fontWeight: 600,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    marginBottom: theme.spacing(1),
  },
}));

export const CollapsibleFilters = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <FilterListIcon className={classes.filterIcon} />
        Filtros
      </div>
      <EntityKindPicker initialFilter="system" />
      <EntityTypePicker />
      <EntityOwnerPicker mode="owners-only" />
      <EntityLifecyclePicker />
      <EntityTagPicker />
      <EntityProcessingStatusPicker />
      <EntityNamespacePicker />
      <div className={classes.separator}>
        <span className={classes.quickAccessTitle}>Acesso Rapido</span>
        <UserListPicker initialFilter="all" />
      </div>
    </div>
  );
};
